// Stripe.js instances are cached per (publishable key, connected account) pair.
// SetupIntents for guest checkout/payment are created by the platform on the
// organization's connected account, so Stripe.js must be initialized with that
// account or confirming the intent fails with "No such setupintent".
const stripeInstances = new Map();

const stripeInstanceKey = (publishableKey, stripeAccountId) =>
  `${publishableKey || ''}|${stripeAccountId || ''}`;

const getStripePromise = (loader, publishableKey, stripeAccountId) => {
  if (!publishableKey) return null;

  const key = stripeInstanceKey(publishableKey, stripeAccountId);
  if (!stripeInstances.has(key)) {
    stripeInstances.set(
      key,
      stripeAccountId
        ? loader(publishableKey, { stripeAccount: stripeAccountId })
        : loader(publishableKey)
    );
  }
  return stripeInstances.get(key);
};

module.exports = { getStripePromise, stripeInstanceKey };
